if (!customElements.get('flipbook-viewer')) {
  customElements.define(
    'flipbook-viewer',
    class FlipbookViewer extends HTMLElement {
      constructor() {
        super();
        this.currentSpread = 0;
        this.isFlipping = false;
        this.flipDuration = 700;
      }

      connectedCallback() {
        this.stage = this.querySelector('.flipbook__stage');
        this.sheets = Array.from(this.querySelectorAll('.flipbook__sheet'));
        this.totalSheets = this.sheets.length;
        this.prevBtn = this.querySelector('.flipbook__nav--prev');
        this.nextBtn = this.querySelector('.flipbook__nav--next');
        this.counter = this.querySelector('.flipbook__counter-current');
        this.pageCount = parseInt(this.dataset.pageCount, 10) || 0;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.flipBack();
          });
        }

        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.flipForward();
          });
        }

        if (this.stage) {
          this.stage.addEventListener('click', this.onStageClick.bind(this));
        }

        this.updateNavState();
      }

      onStageClick(event) {
        const rect = this.stage.getBoundingClientRect();
        const x = event.clientX - rect.left;
        if (x < rect.width / 2) {
          this.flipBack();
        } else {
          this.flipForward();
        }
      }

      flipForward() {
        this.goToSpread(this.currentSpread + 1);
      }

      flipBack() {
        this.goToSpread(this.currentSpread - 1);
      }

      goToSpread(target) {
        if (this.isFlipping) return;
        const clamped = Math.max(0, Math.min(this.totalSheets, target));
        if (clamped === this.currentSpread) return;

        const direction = clamped > this.currentSpread ? 1 : -1;
        const flippingIndex = direction > 0 ? this.currentSpread : this.currentSpread - 1;
        const flippingSheet = this.sheets[flippingIndex];

        this.isFlipping = true;
        this.currentSpread = clamped;

        // Lift the flipping sheet above all others during the animation
        if (flippingSheet) {
          flippingSheet.style.zIndex = 1000;
        }

        this.applyFlippedClasses();

        const cleanup = () => {
          this.applyZIndices();
          this.isFlipping = false;
          this.updateNavState();
        };

        if (flippingSheet) {
          let done = false;
          const onEnd = (e) => {
            if (e.target !== flippingSheet || e.propertyName !== 'transform') return;
            if (done) return;
            done = true;
            flippingSheet.removeEventListener('transitionend', onEnd);
            cleanup();
          };
          flippingSheet.addEventListener('transitionend', onEnd);
          // Fallback in case transitionend doesn't fire
          setTimeout(() => {
            if (done) return;
            done = true;
            flippingSheet.removeEventListener('transitionend', onEnd);
            cleanup();
          }, this.flipDuration + 100);
        } else {
          cleanup();
        }

        this.updateCounter();
      }

      applyFlippedClasses() {
        this.sheets.forEach((sheet, i) => {
          sheet.classList.toggle('is-flipped', i < this.currentSpread);
        });
      }

      applyZIndices() {
        this.sheets.forEach((sheet, i) => {
          // Flipped sheets stack on the left (last flipped on top).
          // Unflipped sheets stack on the right (next-to-flip on top).
          const z = i < this.currentSpread
            ? i + 1
            : this.totalSheets - i + 100;
          sheet.style.zIndex = z;
        });
      }

      updateNavState() {
        if (this.prevBtn) this.prevBtn.disabled = this.currentSpread === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.currentSpread === this.totalSheets;
      }

      updateCounter() {
        if (!this.counter) return;
        // Show the current right-side page number (1-indexed). When fully
        // flipped to the end, show the last page.
        let current = this.currentSpread * 2 + 1;
        if (current > this.pageCount) current = this.pageCount;
        this.counter.textContent = String(current);
      }
    }
  );
}
